export default "__VITE_ASSET__CCXqbX1o__"